export const THEME_MODES = {
  LIGHT: "light",
  DARK: "dark",
};

const THEME_STORAGE_KEY = "gn4_themeMode";

export const readThemeMode = () => {
  try {
    return localStorage.getItem(THEME_STORAGE_KEY) || THEME_MODES.LIGHT;
  } catch {
    return THEME_MODES.LIGHT;
  }
};

export const persistThemeMode = (mode) => {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, mode);
  } catch (err) {
    console.warn("No se pudo persistir el tema en localStorage:", err);
  }
};
